<div
  #tooltipSingleton
  class="absolute top-0 left-0 z-200 border border-zinc-700 wrap-break-word dark:border-zinc-200"
  [class]="classes()"
  [class.pointer-events-auto]="interactive()"
  [class.pointer-events-none]="!interactive()"
  [style.transition]="'opacity 200ms'">
  @if (tooltipType() === 'default') {
    <span [innerHTML]="content()"></span>
  } @else if (tooltipType() === 'info') {
    @if (title()) {
      <div class="mb-1 flex items-baseline gap-2 font-medium">
        <span
          class="min-w-0 truncate text-zinc-100 dark:text-zinc-800"
          [innerHTML]="title()"></span>
        @if (titleSuffix()) {
          <span
            class="shrink-0 text-zinc-100 dark:text-zinc-800"
            [innerHTML]="titleSuffix()"></span>
        }
      </div>
    }

    @if (content()) {
      <div
        class="min-h-0 overflow-y-auto overscroll-contain text-zinc-200 [scrollbar-width:thin] dark:text-zinc-700"
        [innerHTML]="content()"></div>
    }

    @if (showHint() && hintText()) {
      <div
        class="mt-2 border-t border-zinc-600 pt-2 text-xs text-zinc-300 opacity-75 dark:border-zinc-400 dark:text-zinc-600"
        [innerHTML]="hintText()"></div>
    }
  } @else {
    @if (title()) {
      <div class="mb-1 flex items-baseline gap-2 font-normal">
        <span
          class="min-w-0 truncate text-zinc-100 dark:text-zinc-800"
          [innerHTML]="title()"></span>
        @if (titleSuffix()) {
          <span
            class="shrink-0 text-zinc-100 dark:text-zinc-800"
            [innerHTML]="titleSuffix()"></span>
        }
      </div>
    }
    @if (content() && !showDetails()) {
      <div
        class="min-h-0 overflow-y-auto overscroll-contain text-zinc-200 [scrollbar-width:thin] dark:text-zinc-700"
        [innerHTML]="content()"></div>
    }

    @if (showDetails() && details()) {
      <div
        class="min-h-0 overflow-y-auto overscroll-contain text-zinc-200 [scrollbar-width:thin] dark:text-zinc-700"
        [innerHTML]="details()"></div>
    }
    <div
      class="mt-2 flex justify-center border-t border-zinc-600 pt-2 text-xs text-zinc-300 opacity-75 dark:border-zinc-400 dark:text-zinc-600">
      <div
        (click)="toggleDetails()"
        (keydown.enter)="toggleDetails()"
        class="cursor-pointer text-zinc-500 hover:text-zinc-400 dark:text-zinc-400 dark:hover:text-zinc-300">
        @if (showDetails()) {
          {{ 'common.collapse' | translate }}
        } @else {
          {{ 'common.expand' | translate }}
        }
      </div>
    </div>
  }
</div>
